<template>
  <CSidebar
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
    class="sidebar"
    style="color: white !important"
  >
    <CSidebarNav>
      <br>
      <br>
      <br>

    <AppSidebarNav
    />
  </CSidebarNav>

  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '@/assets/brand/logo-negative'
import { sygnet } from '@/assets/brand/sygnet'
import router from '@/router'
export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore()
    store.commit('updateSidebarVisible', true)

    let breadcrumbs2 = router.currentRoute.value.name

    // console.log('breadcrumbs2 = >', breadcrumbs2)
    if (breadcrumbs2 == 'NEW REQUEST' || breadcrumbs2 == 'APPROVER VIEW') {
      store.state.sidebarVisible = false
    }

    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
</script>
<style>
div.sidebar {
  position: fixed;
  /* background-color: #83c9fb; */
  /* bottom: 0; */
/* margin-top: 200px; */
  /* right: 0; */
  /* top: 100; */
  /* width: 300px; */
  /* border: 3px solid #73ad21; */


}
</style>
